import {
  ROOT,
  SYNCOTA_GET_ALL,
  SYNCOTA_GET_CONNECTED,
  SYNCOTA_GET_DETAIL,
  SYNCOTA_UPDATE_DETAIL,
  SYNCOTA_CREATE_CONNECT,
  SYNCOTA_GET_ALL_CHAIN,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS,
  SYNCOTA_GET_CONNECTED_GDS,
  SYNCOTA_GET_DETAIL_GDS,
  SYNCOTA_CREATE_CONNECT_GDS,
  SYNCOTA_UPDATE_DETAIL_GDS,
  DISCONNECTED_GDS,
  ROOM_RATR_OTA,
  SYNCOTA_GET_DETAIL_SITE_MINDER,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_SITE_MINDER,
  SYNCOTA_GET_CONNECTED_SITE_MINDER,
  SYNCOTA_CREATE_CONNECT_SITE_MINDER,
  SYNCOTA_UPDATE_DETAIL_SITE_MINDER,
  DISCONNECTED_SITE_MINDER,

  SYNCOTA_GET_DETAIL_BE,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE,
  SYNCOTA_GET_CONNECTED_BE,
  SYNCOTA_CREATE_CONNECT_BE,
  ROOM_RATR_OTA_1I,
  ROOM_RATR_OTA_1X,
  SYNCOTA_GET_DETAIL_GDS_CTRIP,
  SYNCOTA_UPDATE_DETAIL_GDS_CTRIP,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1X,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1I,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1T,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1S,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1H,
  SYNCOTA_CREATE_CONNECT_GDS_1X,
  SYNCOTA_CREATE_CONNECT_GDS_1I,
  SYNCOTA_CREATE_CONNECT_GDS_1T,
  SYNCOTA_CREATE_CONNECT_GDS_1H,
  SYNCOTA_CREATE_CONNECT_GDS_1S,
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";
import { 
  DISCONNECTED_GDS_1H, 
  DISCONNECTED_GDS_1I, 
  DISCONNECTED_GDS_1S, 
  DISCONNECTED_GDS_1T, 
  DISCONNECTED_GDS_1X, 
  SYNCOTA_GET_CONNECTED_GDS_1H, 
  SYNCOTA_GET_CONNECTED_GDS_1I, 
  SYNCOTA_GET_CONNECTED_GDS_1S, 
  SYNCOTA_GET_CONNECTED_GDS_1T, 
  SYNCOTA_GET_CONNECTED_GDS_1X, 
  SYNCOTA_GET_DETAIL_GDS_1H, 
  SYNCOTA_GET_DETAIL_GDS_1I, 
  SYNCOTA_GET_DETAIL_GDS_1S, 
  SYNCOTA_GET_DETAIL_GDS_1T, 
  SYNCOTA_GET_DETAIL_GDS_1X, 
  SYNCOTA_UPDATE_DETAIL_GDS_1H, 
  SYNCOTA_UPDATE_DETAIL_GDS_1I, 
  SYNCOTA_UPDATE_DETAIL_GDS_1S, 
  SYNCOTA_UPDATE_DETAIL_GDS_1T, 
  SYNCOTA_UPDATE_DETAIL_GDS_1X,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE_APP,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE_KIOS,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE_PMS,
  SYNCOTA_GET_DETAIL_BE_APP,
  SYNCOTA_GET_CONNECTED_BE_APP,
  SYNCOTA_CREATE_CONNECT_BE_APP,
  SYNCOTA_GET_DETAIL_BE_KIOS,
  SYNCOTA_GET_CONNECTED_BE_KIOS,
  SYNCOTA_CREATE_CONNECT_BE_KIOS,
  SYNCOTA_GET_DETAIL_BE_PMS,
  SYNCOTA_GET_CONNECTED_BE_PMS,
  SYNCOTA_CREATE_CONNECT_BE_PMS,
  GET_ALL_OTA_GROUP, CHANNEX_SYNC_DATA, SITEMIDER_SYNC_DATA, PRICELABS_SYNC_DATA, EZ_CMS_1T_SYNC_DATA, SU_SYNC_DATA,
  EZ_CMS_1I_SYNC_DATA,
  TRAVELOKA_SYNC_DATA,
  SYNCOTA_GET_ALL_OTA_NOT_CONNECT_TRAVELOKA,
  SYNCOTA_GET_CONNECTED_TRAVELOKA,
  SYNCOTA_GET_DETAIL_TRAVELOKA,
  SYNCOTA_CREATE_CONNECT_TRAVELOKA,
  SYNCOTA_UPDATE_DETAIL_TRAVELOKA,
  DISCONNECTED_TRAVELOKA,
  GET_OTA_ROOM_TRAVELOKA,
  SYNCOTA_UPDATE_EXTRA_TRAVELOKA,
  SYNCOTA_UPDATE_EXTRA_SU
} from "../../_helpers/constant";

function getAllOTA(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllOTANotConnect(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnect1x(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnect1i(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnect1t(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllOTANotConnect1s(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnect1h(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllOTAChain(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_CHAIN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}



function getConnectedOTA(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function createConnectOTA(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function detailSyncOTA(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateDetailSyncOTA(data) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllOTANotConnectGds(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnectGds1x(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1X, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnectGds1i(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1I, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnectGds1s(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1S, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnectGds1t(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1T, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnectGds1h(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1H, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getConnectedOTAGds(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_GDS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getConnectedOTAGds1x(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_GDS_1X, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getConnectedOTAGds1i(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_GDS_1I, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getConnectedOTAGds1s(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_GDS_1S, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getConnectedOTAGds1t(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_GDS_1T, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getConnectedOTAGds1h(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_GDS_1H, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function detailSyncOTAGds(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_GDS + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detailSyncOTAGds1x(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_GDS_1X + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detailSyncOTAGds1i(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_GDS_1I + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detailSyncOTAGds1t(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_GDS_1T + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detailSyncOTAGds1s(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_GDS_1S + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detailSyncOTAGds1h(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_GDS_1H + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function createConnectOTAGds(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_GDS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createConnectOTAGds1x(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_GDS_1X, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createConnectOTAGds1i(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_GDS_1I, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createConnectOTAGds1t(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_GDS_1T, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createConnectOTAGds1h(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_GDS_1H, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createConnectOTAGds1s(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_GDS_1S, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateDetailSyncOTAGds(data, otaId) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL_GDS + `/${otaId}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateDetailSyncOTAGds1x(data, otaId) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL_GDS_1X + `/${otaId}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateDetailSyncOTAGds1i(data, otaId) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL_GDS_1I + `/${otaId}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateDetailSyncOTAGds1s(data, otaId) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL_GDS_1S + `/${otaId}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateDetailSyncOTAGds1t(data, otaId) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL_GDS_1T + `/${otaId}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateDetailSyncOTAGds1h(data, otaId) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL_GDS_1H + `/${otaId}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function disconnectOTAGds(data) {
  return fetch(ROOT + DISCONNECTED_GDS + `/${data}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function disconnectOTAGds1x(data) {
  return fetch(ROOT + DISCONNECTED_GDS_1X + `/${data}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function disconnectOTAGds1i(data) {
  return fetch(ROOT + DISCONNECTED_GDS_1I + `/${data}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function disconnectOTAGds1s(data) {
  return fetch(ROOT + DISCONNECTED_GDS_1S + `/${data}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function disconnectOTAGds1t(data) {
  return fetch(ROOT + DISCONNECTED_GDS_1T + `/${data}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function disconnectOTAGds1h(data) {
  return fetch(ROOT + DISCONNECTED_GDS_1H + `/${data}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getRoomRateOta(data) {
  return fetch(ROOT + ROOM_RATR_OTA + `/${data}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
// siteMinder

function detailSyncOTASiteMinder(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_SITE_MINDER + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getRoomRateOta1i(data) {
  return fetch(ROOT + ROOM_RATR_OTA_1I + `/${data}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getRoomRateOta1x(data) {
  return fetch(ROOT + ROOM_RATR_OTA_1X + `/${data}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllOTANotConnectSiteMinder(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_SITE_MINDER, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
// BE
function detailSyncOTABe(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_BE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detailSyncOTABeApp(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_BE_APP + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detailSyncOTABeKios(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_BE_KIOS + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detailSyncOTABePms(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_BE_PMS + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getConnectedOTASiteMinder(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_SITE_MINDER, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnectBe(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnectBeApp(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE_APP, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnectBeKios(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE_KIOS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOTANotConnectBePms(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE_PMS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function createConnectOTASiteMinder(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_SITE_MINDER, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateDetailSyncOTASiteMinder(data, otaId) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL_SITE_MINDER + `/${otaId}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getConnectedOTABe(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_BE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getConnectedOTABeApp(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_BE_APP, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getConnectedOTABeKios(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_BE_KIOS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getConnectedOTABePms(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_BE_PMS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function disconnectOTASiteMinder(data) {
  return fetch(ROOT + DISCONNECTED_SITE_MINDER + `/${data}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createConnectOTABe(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_BE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createConnectOTABeApp(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_BE_APP, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createConnectOTABeKios(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_BE_KIOS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createConnectOTABePms(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_BE_PMS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function detailSyncOTAGdsCTrip(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_GDS_CTRIP + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateDetailSyncOTAGdsCtrip(data, otaId) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL_GDS_CTRIP + `/${otaId}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function channexSyncData(id) {
  return fetch(ROOT + CHANNEX_SYNC_DATA + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function suSyncData(id) {
  return fetch(ROOT + SU_SYNC_DATA+ `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function sitemiderSyncData(id) {
  return fetch(ROOT + SITEMIDER_SYNC_DATA + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function cms1tSyncData(id) {
  return fetch(ROOT + EZ_CMS_1T_SYNC_DATA + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function cms1iSyncData(id) {
  return fetch(ROOT + EZ_CMS_1I_SYNC_DATA + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function pricesLabSyncData(id) {
  return fetch(ROOT + PRICELABS_SYNC_DATA + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllOTAGroup() {
  return fetch(ROOT + GET_ALL_OTA_GROUP, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

// traveloka
function travelokaSyncData(id) {
  return fetch(ROOT + TRAVELOKA_SYNC_DATA + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllOTANotConnectTraveloka(data) {
  return fetch(ROOT + SYNCOTA_GET_ALL_OTA_NOT_CONNECT_TRAVELOKA, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getConnectedOTATraveloka(data) {
  return fetch(ROOT + SYNCOTA_GET_CONNECTED_TRAVELOKA, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function detailSyncOTATraveloka(id) {
  return fetch(ROOT + SYNCOTA_GET_DETAIL_TRAVELOKA + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function createConnectOTATraveloka(data) {
  return fetch(ROOT + SYNCOTA_CREATE_CONNECT_TRAVELOKA, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateDetailSyncOTATraveloka(data, otaId) {
  return fetch(ROOT + SYNCOTA_UPDATE_DETAIL_TRAVELOKA + `/${otaId}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function disconnectOTATraveloka(data) {
  return fetch(ROOT + DISCONNECTED_TRAVELOKA + `/${data}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getOTARoomTraveloka(otaId) {
  return fetch(ROOT + GET_OTA_ROOM_TRAVELOKA + `?id=${otaId}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateExtraTraveloka(data) {
  return fetch(ROOT + SYNCOTA_UPDATE_EXTRA_TRAVELOKA, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateExtraSu(data) {
  return fetch(ROOT + SYNCOTA_UPDATE_EXTRA_SU, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//#endregion
export const syncota = {
  getAllOTA,
  getConnectedOTA,
  createConnectOTA,
  detailSyncOTA,
  updateDetailSyncOTA,
  getAllOTAChain,
  getAllOTANotConnect,
  getAllOTANotConnectGds,
  getAllOTANotConnectGds1i,
  getAllOTANotConnectGds1x,
  getAllOTANotConnectGds1t,
  getAllOTANotConnectGds1s,
  getAllOTANotConnectGds1h,
  getConnectedOTAGds,
  getConnectedOTAGds1x,
  getConnectedOTAGds1i,
  getConnectedOTAGds1s,
  getConnectedOTAGds1t,
  getConnectedOTAGds1h,
  detailSyncOTAGds,
  detailSyncOTAGds1x,
  detailSyncOTAGds1i,
  detailSyncOTAGds1t,
  detailSyncOTAGds1s,
  detailSyncOTAGds1h,
  createConnectOTAGds1x,
  createConnectOTAGds1i,
  createConnectOTAGds1t,
  createConnectOTAGds1h,
  createConnectOTAGds1s,
  createConnectOTAGds,
  updateDetailSyncOTAGds,
  updateDetailSyncOTAGds1x,
  updateDetailSyncOTAGds1i,
  updateDetailSyncOTAGds1t,
  updateDetailSyncOTAGds1s,
  updateDetailSyncOTAGds1h,
  disconnectOTAGds,
  disconnectOTAGds1x,
  disconnectOTAGds1i,
  disconnectOTAGds1s,
  disconnectOTAGds1t,
  disconnectOTAGds1h,
  getRoomRateOta,
  detailSyncOTASiteMinder,
  getAllOTANotConnectSiteMinder,
  disconnectOTASiteMinder,
  updateDetailSyncOTASiteMinder,
  createConnectOTASiteMinder,
  getConnectedOTASiteMinder,
  detailSyncOTABe,
  detailSyncOTABeApp,
  detailSyncOTABeKios,
  detailSyncOTABePms,
  getAllOTANotConnectBe,
  getAllOTANotConnectBeApp,
  getAllOTANotConnectBeKios,
  getAllOTANotConnectBePms,
  getConnectedOTABe,
  createConnectOTABe,
  getConnectedOTABeApp,
  createConnectOTABeApp,
  getConnectedOTABeKios,
  createConnectOTABeKios,
  getConnectedOTABePms,
  createConnectOTABePms,
  getRoomRateOta1i,
  getRoomRateOta1x,
  detailSyncOTAGdsCTrip,
  updateDetailSyncOTAGdsCtrip,
  getAllOTAGroup,
  channexSyncData,
  suSyncData,
  sitemiderSyncData,
  cms1tSyncData,
  pricesLabSyncData,
  cms1iSyncData,
  travelokaSyncData,
  getAllOTANotConnectTraveloka,
  getConnectedOTATraveloka,
  detailSyncOTATraveloka,
  createConnectOTATraveloka,
  updateDetailSyncOTATraveloka,
  disconnectOTATraveloka,
  getOTARoomTraveloka,
  updateExtraTraveloka,
  updateExtraSu
}